import { Component, Host, h } from '@stencil/core';

/**
 * @slot - Designed to add custom content inside the card content.
 */
@Component({
  tag: 'sy-card-content',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class CardContent {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
